import type { Response } from '@onramp/server/types';

/** Checks for user auth using usm or legacy auth, depending on experiment group. */
export function getHasAuthCookie(res: Response) {
  res.logger.info('getHasAuthCookie UUID', {
    deviceId: res.locals.deviceId,
    userUuid: res.locals.userUuid,
    haveUsmCookie: res.locals.unifiedSessionManagerCookie !== undefined,
  });
  return res.locals.userUuid !== undefined;
}
